module.exports = __webpack_public_path__ + "ccccacddc8b82d0944ef7e039f67c485.png";